import React, { useState, useMemo, useEffect } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { ApiService } from '../api';
import { useNavigate } from 'react-router-dom';

const useTokenUpdate = () => {
  const api = useMemo(() => new ApiService(), []);

  const navigate = useNavigate();

  const tokenUpdate = async () => {
    try {
      const newToken = await api.getNewToken(
        String(sessionStorage.getItem('refreshToken')),
      );
      sessionStorage.setItem('accessToken', newToken.accessToken);
      sessionStorage.setItem('refreshToken', newToken.refreshToken);
    } catch (err) {
      sessionStorage.clear();
      navigate('/login');
    }
  };

  useEffect(() => {
    tokenUpdate();
    // const checkAndUpdateToken = () => {
    //   tokenUpdate();
    // };

    // const interval = setInterval(checkAndUpdateToken, 1000 * 60 * 13);
    // return () => clearInterval(interval);
  }, []);

  return null;
};

export default useTokenUpdate;
